/* eslint-disable no-trailing-spaces */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { STATUS, API, encrypt, parseQueryString } from '@vezeeta/web-utils';
import Cookies from 'js-cookie';
import CreditCard from '@vezeeta/credit-card-component';
import { SignupStep, Spinner } from '@vezeeta/web-components'; // eslint-disable-line import/first
import configurations from './Config';
import './Payment.scss';
import '../../shared/Utils.scss';
import { deleteCookies, detectCultureFromDoctorUrl, getDomain, detectPaymentType } from '../../shared/payment-utils';

const encryptionKey = 'MadMed117';
class Payment extends Component {
  constructor(props) {
    super(props);

    this.PaymentAuthHeaders = [
      {
        key: 'x-vzt-Component',
        value: 'paymentportal',
      },
      {
        key: 'x-vzt-authorization',
        value: 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJhcHBpZCI6InNlcnZpY2VzIiwiZXhwIjoxNTI0NDE0MDkxLjAsIm5uYyI6IjU4MDllYmIyYWQ2YjdmMmMifQ.lcVf-afeEm8KIpqFaMT3Y7hpyrPWg6fNic8Ew9YyU6k',
      },
    ];
    Cookies.set('LogoClickStatus', true, {
      expires: 1 / (24 * 4),
    });
    let urlToParse = window.location.search;
    if (urlToParse === '') {
      this.TransactionKey = Cookies.get('TK');
      this.firstentry = false;
    } else {
      urlToParse = decodeURIComponent(urlToParse);
      this.result = parseQueryString(urlToParse);
      // this is to use fullPathCallBackUrl (instead of calculating it) if
      // the variable useFullPathUrl is set to true
      this.useFullPathUrl = this.result.useFullPathUrl;
      this.fullPathCallBackUrl = this.result.fullPathCallBackUrl;
      this.paymentType = detectPaymentType(this.result);
      this.CountryId = this.result.countryId;
      Cookies.set('CD', this.CountryId, {
        expires: 1 / (24 * 4),
      });
      window.history.replaceState(null, null, window.location.pathname);
      Cookies.set('TK', this.result.transactionKey, {
        expires: 1 / (24 * 4),
      });
      Cookies.set('useFullPathUrl', this.result.useFullPathUrl, {
        expires: 1 / (24 * 4),
      });
      Cookies.set('fullPathCallBackUrl', this.result.fullPathCallBackUrl, {
        expires: 1 / (24 * 4),
      });
      Cookies.set('paymentMethod', this.result.paymentMethod, {
        expires: 1 / (24 * 4),
      });
      // if forceCallbackHost is sent as a query string to payment portal, then it overirdes the host
      // that payment portal redirect to in case of successfule credit card payment (default is env variable)
      Cookies.set('callbackHost', this.result.forceCallbackHost, {
        expires: 1 / (24 * 4),
      });
      // if forceCallbackRelativepath is sent as a query string to payment portal, then it overirdes the relative path
      // that payment portal redirect to in case of successfule credit card payment (default is env variable)
      Cookies.set('callbackRelativePath', this.result.forceCallbackRelativePath, {
        expires: 1 / (24 * 4),
      });
      // if addReservationKeyToCallbackURL is sent as a query string to payment portal, then it adds a query
      // string to the url that payment portal redirect to in case of successfule credit card payment (default is env variable)
      Cookies.set('RKcallbackQuery', this.result.addReservationKeyToCallbackURL, {
        expires: 1 / (24 * 4),
      });
      if (this.paymentType.type === 'reservation') {
        Cookies.set('RK', this.result.reservationKey, {
          expires: 1 / (24 * 4),
        });
        Cookies.set('CallBack', this.result.callBackUrl, {
          expires: 1 / (24 * 4),
        });
        this.vezeetaUrl = getDomain(this.result.callBackUrl, true);
        Cookies.set('VezeetaUrl', this.vezeetaUrl, {
          expires: 1 / (24 * 4),
        });
      } else {
        const BookingCallBack = decodeURIComponent(this.paymentType.url);
        Cookies.set('BookingCallBack', BookingCallBack, {
          expires: 1 / (24 * 4),
        });
      }
      Cookies.set('PhoneNumber', this.result.mobileNumber, {
        expires: 1 / (24 * 4),
      });
      Cookies.set('PaymentType', this.paymentType.type, {
        expires: 1 / (24 * 4),
      });
      this.firstentry = true;
    }
    this.state = {
      AmountDue: '',
      transactionKey: '',
      currency: '',
      AccountKey: '',
      isLoadingConfig: true,
      signature: '',
      merchantReference: '',
      token: '',
      merchantIdentifier: '',
      accessCode: '',
      paymentMethod: this.result ? this.result.paymentMethod : Cookies.get('paymentMethod'),
    };
  }
  componentDidMount() {
    if (Cookies.get('PaymentType') === 'reservation') {
      this.CultureLanguage = detectCultureFromDoctorUrl(Cookies.get('CallBack'));
    } else {
      this.CultureLanguage = {
        LanguageId: 1,
        culture: 'en-US',
        RedirectCulture: '/en/',
      };
    }
    setTimeout(() => { this.callGetTransactionDataApi(); }, 3000);
  }

  callGetTransactionDataApi = () => {
    const cookies = ['CD', 'AK', 'TK', 'RK', 'CID', 'PTK', 'CallBack', 'VezeetaUrl', 'BookingCallBack', 'LogoClickStatus', 'callBackAttributes', 'callbackHost', 'callbackRelativePath', 'RKcallbackQuery', 'amountPaid'];
    this.TransactionKey = Cookies.get('TK');
    const transactionDataUrl = configurations.transactionDataUrl;
    const transactionInfo = new API();
    transactionInfo
      .get(`${transactionDataUrl}${this.TransactionKey}`, this.PaymentAuthHeaders)
      .then((response) => {
        if (response.status === STATUS.SUCCESS) {
          this.setState({
            AccountKey: response.data.AccountKey,
            currency: response.data.Currency.Name,
          });
          Cookies.set('CID', response.data.CurrencyId, {
            expires: 1 / (24 * 4),
          });
          Cookies.set('amountPaid', response.data.AmountPaid, {
            expires: 1 / (24 * 4),
          });
          this.transactionData(response.data.AmountDue, this.TransactionKey);
        } else if (Cookies.get('RK') !== undefined) {  
          // eslint-disable-next-line react/prop-types
          this.props.history.push('/check');
          this.stateCallBack(false);
          deleteCookies(cookies);
        }
      })
      .then(() => {
        const accountCardData = {
          AccountKey: this.state.AccountKey,
          CountryId: Cookies.get('CD'),
          PaymentTypeKey: 'pt40673dcc85812a0',
          returnUrl: configurations.returnUrl,
          TransactionKey: this.TransactionKey,
        };
        const addAccountCardAndGetMerchantPageInfo = new API();
        const addAccountCardAndGetMerchantPageInfoUrl =
          configurations.addAccountCardAndGetMerchantPageInfoUrl;
        addAccountCardAndGetMerchantPageInfo
          .post(addAccountCardAndGetMerchantPageInfoUrl, accountCardData, this.PaymentAuthHeaders)
          .then((response) => {
            this.setState({
              signature: response.data.ReturnObject.Signature,
              merchantReference:
                response.data.ReturnObject.MerchantReference,
              token: response.data.ReturnObject.Token,
              isLoadingConfig: false,
              merchantIdentifier: response.data.ReturnObject.MerchantId,
              accessCode: response.data.ReturnObject.AccessCode,
            });
            Cookies.set(
              'AK',
              encrypt(this.state.AccountKey, encryptionKey),
              {
                expires: 1 / (24 * 4),
              },
            );
            Cookies.set(
              'PTK',
              encrypt(accountCardData.PaymentTypeKey, encryptionKey),
              {
                expires: 1 / (24 * 4),
              },
            );
          });
      });
  };
  transactionData = (AmountDue, TransactionKey) => {
    this.setState({
      AmountDue,
      transactionKey: TransactionKey,
    });
  };

  stateCallBack = () => {
    if (Cookies.get('PaymentType') === 'reservation') {
      deleteCookies(this.cookies);
      window.location.replace(this.vezeetaUrl);
    }
  };
  titleHandle = () => {
    const { paymentMethod } = this.state;
    if (paymentMethod === 'MadaCard') {
      return 'Pay with Mada Card';
    }
    const { brandKey } = this.props;

    return brandKey ? 'Credit Card Payment Option' : 'Vezeeta Credit Card Payment Option';
  }
  render() {
    const {
      paymentMethod, isLoadingConfig, merchantIdentifier, accessCode,
    } = this.state;
    if (isLoadingConfig) {
      return (
        <div className="center centerVertically">
          <Spinner />
        </div>
      );
    }
    return (
      <div>
        <SignupStep
          title={this.titleHandle()}
          desc=""
          hideBackButton
        />
        <CreditCard
          merchantIdentifier={merchantIdentifier}
          payfortMerchantPageLink={configurations.payfortMerchantPageLink}
          returnUrl={configurations.returnUrl}
          accessCode={accessCode}
          servicesCommand={configurations.servicesCommand}
          language={configurations.language}
          rememberMe={configurations.rememberMe}
          amount={this.state.AmountDue}
          currency={this.state.currency}
          transactionKey={this.state.transactionKey}
          merchantReference={this.state.merchantReference}
          token={this.state.token}
          signature={this.state.signature}
          isMada={paymentMethod === 'MadaCard'}
        />
      </div>
    );
  }
}

Payment.propTypes = {
  brandKey: PropTypes.string,
};
Payment.defaultProps = {
  brandKey: null,
};
export default Payment;



// WEBPACK FOOTER //
// ./src/views/payment/Payment.js